import { useEffect, useState } from 'react';
import { Navigate, Outlet, Route, BrowserRouter as Router, Routes, useLocation } from 'react-router-dom';
import 'react-toastify/dist/ReactToastify.css';
import authApi from './api/auth';
import usersApi from './api/users';
import Header from './components/Header';
import Nav from './components/Nav';
import { useAppDispatch, useAppSelector } from './hooks';
import Account from './pages/Account';
import Personal from './pages/Account/Profile/Personal';
import Settings from './pages/Account/Settings';
import ComingSoon from './pages/ComingSoon';
import ExploreTutorByType from './pages/Explore/ExploreTutorByType';
import FindTutor from './pages/FindTutor/FindTutor';
import Home from './pages/Home/Home';
import Landing from './pages/Landing/Landing';
import Login from './pages/Login/Login';
import PostRequirement from './pages/PostRequirement/PostRequirement';
import RaiseTicket from './pages/RaiseATicket/RaiseTicket';
import Requirements from './pages/Requirements';
import Myrequirements from './pages/Requirements/Myrequirements/Myrequirements';
import TransferRequests from './pages/Requirements/TransferRequests/TransferRequests';
import TutorProfile from './pages/TutorProfile';
import { login } from './reducers/authSlice';
import { getUserByEmail, setUserProfile } from './reducers/userSlice';
import { setVisitorInfo } from './reducers/visitorInfoSlice';
import { getCurrencyFromCode, getVisitorCurrencyRate, getVisitorInfo } from './utils/getVisitorInfo';
// @ts-ignore
import CountryQuery from 'country-query';
import MyCalender from './pages/MyCalender';
import { setPreferences } from './reducers/preferences';
import Checkout from './pages/TutorProfile/Purchase Plan/Checkout';
import PaymentProcessing from './pages/TutorProfile/Purchase Plan/PaymentProcessing';
import MyPlans from './pages/MyPlans';
import Transactions from './pages/Account/Transactions';
import Attendance from './pages/Attendance';
import PlanAttendance from './pages/Attendance/PlanAttendance';
import SplashScreen from './components/SplashScreen';
import SearchResults from './pages/FindTutor/SearchResults';
import Inbox from './pages/Inbox';
import Contact from './pages/Contact';
import Legal from './pages/Legal';
import About from './pages/About';
import Notifications from './pages/Notifications';
import BookFreeTrail from './pages/BookFreeTrail';
import ThankYou from './pages/ThankYou';
import Registration from './pages/Registration';
import PayNow from './pages/PayNow';
import SubjectData  from './pages/Curriculum/subjectDetails';
import NewLanding from './pages/Landing/NewLanding';
import Subjects from './pages/Curriculum/Subjects';
import ExploreSubjectCategory from './pages/Explore/ExploreSubjectCategory';
import StaySafe from './pages/Policies/StaySafe';
import ShareStory from './pages/Policies/ShareStory';
import { BsWhatsapp } from 'react-icons/bs';
import RefundPolicy from './pages/Policies/RefundPolicy';
import PaymentConformation from './pages/PaymentConformation'
function App() {
  const dispatch = useAppDispatch();
  const [loading, setLoading] = useState(false);

  const { userData } = useAppSelector((state) => state.userSlice);
  useEffect(() => {
    setLoading(true);
    authApi
      .authStatus()
      .then(async (data) => {
        if (data.status === 'OK' && data.data) {
          dispatch(login(data.data));
          await usersApi
            .getUserByEmail(data.data.email)
            .then(async (data) => {
              if (data) {
                await dispatch(getUserByEmail(data.email));
                setLoading(false);
              } else {
                setLoading(false);
              }
            })
            .catch(() => {
              setLoading(false);
            });
        } else {
          setUserProfile(null);
          setLoading(false);
        }
      })
      .catch(() => {
        setLoading(false);
      });
  }, []);

  useEffect(() => {
    getVisitorInfo().then(async (data) => {
      if (data) {
        const { countryCode } = data;
        if (countryCode) {
          let countryData = CountryQuery.find('cca2', countryCode[1]);
          let currCode = Object.keys(countryData?.currencies)[0];
          let currency = getCurrencyFromCode(currCode);
          let dialCode = countryData.idd.root + countryData.idd.suffixes[0];
          let timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
          let countryName = countryData.name.common;
          getVisitorCurrencyRate(currency.code).then((rate) => {
            dispatch(
              setVisitorInfo({
                countryCode: countryCode[1],
                countryName,
                currency: {
                  ...currency,
                  rate
                },
                dialCode,
                timezone
              })
            );
            dispatch(
              setPreferences({
                timezone: timezone,
                currency: {
                  ...currency,
                  rate
                }
              })
            );
          });
        }
      }
    });
  }, []);

  useEffect(() => {
    if (userData && userData.preference) {
      dispatch(
        setPreferences({
          timezone: userData.preference.timezone,
          currency: userData.preference.currency
        })
      );
    }
  }, [userData]);

  if (loading) {
    return <SplashScreen />;
  }

  return (
    <div className=" mx-auto">
      <Whatsapp/>
      <Router>
        <ScrollToTop>
          <Routes>
            <Route path="/" element={<PublicLayout />}>
              <Route index element={<NewLanding />} />
              <Route path="/explore/:type" element={<ExploreTutorByType />} />
              <Route path="/explore" element={<ExploreSubjectCategory />} />
              <Route path="/find-tutor/:id" element={<TutorProfile />} />
              <Route path="/find-tutor" element={<FindTutor />} />
              <Route path="/search/:query" element={<SearchResults />} />
              <Route path="/post-requirement" element={<PostRequirement />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/legal/:type" element={<Legal />} />
              <Route path="/about" element={<About />} />
                <Route path="/raise-ticket" element={<RaiseTicket />} />
              <Route path="/booktrail" element={<BookFreeTrail />} />
              <Route path="/registration" element={<Registration />} />
              <Route path="/thank-you" element={<ThankYou />} />
              <Route path='/confirmation' element={<PaymentConformation/>}/>
              <Route path="/paynow" element={<PayNow />} />
              <Route path='/subject-details/:slug' element={<SubjectData />} />
              <Route path='/subjects/:id' element={<Subjects/>}/>

              <Route path="/refund-policy" element = {<RefundPolicy/>}/>
              <Route path="/stay-safe" element = {<StaySafe/>}/>
              <Route path="/share-story" element = {<ShareStory/>}/>
            </Route>            

            <Route path="/buy-plan/checkout" element={<Checkout />} />
            <Route path="/buy-plan/checkout-processing" element={<PaymentProcessing />} />

            <Route path="/*" element={<ComingSoon />} />
            <Route path="/login" element={<Login />} />

            <Route path="/" element={<RequireAuth />}>
              <Route path="/" element={<Layout />}>
                <Route path="/dashboard" element={<Home />} />
               
                <Route path="/notifications" element={<Notifications />} />
                <Route path="/requirements" element={<Requirements />}>
                  <Route index element={<Myrequirements />} />
                  <Route path="/requirements/my-requirements" element={<Myrequirements />} />
                  <Route path="/requirements/transfer-requests" element={<TransferRequests />} />
                </Route>
                <Route path="/my-calender" element={<MyCalender />} />
                <Route path="/my-plans" element={<MyPlans />} />
                <Route path="/plans/:planId/attendance" element={<PlanAttendance />} />

                <Route path="/attendance" element={<Attendance />} />
                <Route path="/inbox" element={<Inbox />} />

                <Route path="/account" element={<Account />}>
                  <Route index element={<Personal />} />
                  <Route path="/account/personal" element={<Personal />} />
                  <Route path="/account/settings" element={<Settings />} />
                  <Route path="/account/transactions" element={<Transactions />} />
                </Route>
              </Route>
            </Route>
          </Routes>
        </ScrollToTop>
      </Router>
    </div>
  );
}

const RequireAuth = () => {
  const { user } = useAppSelector((state) => state.authSlice);
  const { userData } = useAppSelector((state) => state.userSlice);
  const location = useLocation();

  if (!user) {
    return <Navigate to={'/login'} replace state={{ prevPath: location.pathname }} />;
  }
  if (!userData) {
    return <Navigate to={'/login'} replace state={{ prevPath: location.pathname }} />;
  }
  return <Outlet />;
};

const Layout = () => {
  const [sidebarOpen, setSideBarOpen] = useState(false);

  const onOpenSidebar = () => {
    setSideBarOpen(true);
    document.body.style.height = '100%';
    document.body.style.overflow = 'hidden';
  };
  const onCloseSidebar = () => {
    setSideBarOpen(false);
    document.body.style.height = '100%';
    document.body.style.overflow = 'auto';
  };
  return (
    <div className="w-full h-full overflow-hidden">
      <Header sidebarOpen={sidebarOpen} onOpenSidebar={onOpenSidebar} onCloseSidebar={onCloseSidebar} />
      <div
        onClick={() => onCloseSidebar()}
        className={`mt-14 md:mt-16 ${
          sidebarOpen
            ? 'absolute top-[10%] transform translate-x-[70%] transition-all rounded-2xl max-h-[80%] overflow-hidden drop-shadow-[-15px_15px_40px_rgba(0,0,0,0.1)] cursor-pointer'
            : 'transition-all'
        }`}
      >
        <Outlet />
      </div>
    </div>
  );
};

const PublicLayout = () => {
  const { userData } = useAppSelector((state) => state.userSlice);
  const [sidebarOpen, setSideBarOpen] = useState(false);

  const onOpenSidebar = () => {
    setSideBarOpen(true);
    document.body.style.height = '100%';
    document.body.style.overflow = 'hidden';
  };
  const onCloseSidebar = () => {
    setSideBarOpen(false);
    document.body.style.height = '100%';
    document.body.style.overflow = 'auto';
  };

  return (
    <div className="w-full h-full ">
      {userData ? (
        <Header sidebarOpen={sidebarOpen} onOpenSidebar={onOpenSidebar} onCloseSidebar={onCloseSidebar} />
      ) : (
        <Nav sidebarOpen={sidebarOpen} onOpenSidebar={onOpenSidebar} onCloseSidebar={onCloseSidebar} />
      )}
      <div
        onClick={() => onCloseSidebar()}
        className={`mt-14 md:mt-16 ${
          sidebarOpen
            ? 'absolute top-[10%] transform translate-x-[75%] transition-all rounded-2xl max-h-[80%] overflow-hidden drop-shadow-[-15px_15px_40px_rgba(0,0,0,0.1)] cursor-pointer'
            : 'transition-all'
        }`}
      >
        <Outlet />
      </div>
    </div>
  );
};

const ScrollToTop = ({ children }: { children: JSX.Element }) => {
  const { pathname, hash, key } = useLocation();

  useEffect(() => {
    // if not a hash link, scroll to top
    if (hash === '') {
      window.scrollTo(0, 0);
    }
    // else scroll to id
    else {
      setTimeout(() => {
        const id = hash.replace('#', '');
        const element = document.getElementById(id);
        if (element) {
          element.scrollIntoView({ behavior: 'smooth' });
        }
      }, 0);
    }
  }, [pathname, hash, key]);

  return <>{children}</>;
};

const Whatsapp = () => {
  const style: React.CSSProperties = {
    position: 'fixed',
    width: '60px',
    height: '60px',
    bottom: '20px',
    right: '20px',
    backgroundColor: '#25d366',
    color: '#FFF',
    borderRadius: '50px',
    textAlign: 'center',
    fontSize: '30px',
    boxShadow: '2px 2px 3px #999',
    zIndex: 1000,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    textDecoration: 'none'
  };

  // Replace with your WhatsApp number (including country code, no '+')
  const phoneNumber = "+917814688725";
  const whatsappUrl = `https://wa.me/${phoneNumber}`;

  return (
    <a href={whatsappUrl} style={style} target="_blank" rel="noopener noreferrer" aria-label="Chat on WhatsApp" className=''>
     <BsWhatsapp/>
    </a>
  );
};


export default App;
